module.exports = __webpack_public_path__ + "static/media/Calendar_Gray.3677bbc4.svg";